import React from 'react'
import store from './../../../init/store.js'

export default class MockTargetPicker extends React.Component {

  renderWarning() {

    //Get our target models
    const targetModels = (this.props.arenaMenuSnapshot.currentlySelectedOptionData.viewBag.targetIds || []).map(targetId => {
      return store.getState().battle.combatants[targetId]
    });

    //If we have valid target models, check the validity of this move on these targets
    if (targetModels.length) {
      const validityModel = this.props.arenaSubmissionMenuAction.getValidity(
        this.props.arenaSubmissionMenuAction,
        {}, //casterModel //(TODO)
        targetModels
      );

      //If we do have warnings, return warning DOM nodes
      if (!validityModel.isValid) {
        const style = {
          color: "#e93434"
        };
        return (
          <div>
            {
              validityModel.invalidReasons.map((invalidReasonText, i) => {
                return <div key={i} style={style}>{invalidReasonText}</div>
              })
            }
          </div>
        )
      }
    }


    //Otherwise, assume there are no warnings!
    return null;
  }

  getTargetingText(action) {
    if (action.targetType === "single-opponent") {
      return "Select one opponent."
    }
    if (action.targetType === "opponent-team") {
      return "Affects entire enemy team."
    }

    if (action.targetType === "single-ally") {
      return "Select one ally."
    }

    if (action.targetType === "ally-team") {
      return "Affects entire friendly team."
    }

    if (action.targetType === "only-me") {
      return "Affects only the caster."
    }

    return "Select Target"

  }

  render() {
    
    const action = this.props.arenaSubmissionMenuAction;

    const containerStyle = {
      paddingTop: "1.2em",
      fontSize: "0.7em"
    };

    const nameStyle = {
      color: "#6EFFDF", //cyan ish
      marginBottom: "1em",
    };
    const descriptionStyle = {
      lineHeight: "1.5em",
      marginBottom: "3em"
    };



    const selectTitleStyle = {
      marginBottom: "1em",
    };

    return (
      <div style={containerStyle}>

        {/*<div style={topSectionStyle}>*/}
        <div style={nameStyle}>{action.name}</div>
        <div style={descriptionStyle}>{action.description}</div>
        {/*</div>*/}


        <div style={selectTitleStyle}>
          {this.getTargetingText(action)}
        </div>

        {/* Maybe render warning text */ }
        { this.renderWarning() }

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/battle/ArenaView/SubmissionMenu/SubmissionTargetMenu.js